// extracted by mini-css-extract-plugin
export default {"avatarBlock":"index-module__Rs4Xr","button":"index-module__ngNbs","noAvatar":"index-module__n7pym"};